import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";

const ClassSelection = ({ control, errors }) => {
  return (
    <FormControl fullWidth error={!!errors.class}>
      <InputLabel>Class</InputLabel>
      <Controller
        name="class"
        control={control}
        rules={{ required: "Class selection is required" }}
        render={({ field }) => (
          <Select {...field} label="Class">
            <MenuItem value="economy">Economy</MenuItem>
            <MenuItem value="business">Business</MenuItem>
            <MenuItem value="first class">First Class</MenuItem>
          </Select>
        )}
      />
      {errors.class && <FormHelperText>{errors.class.message}</FormHelperText>}
    </FormControl>
  );
};

export default ClassSelection;
